<template>
            <div class="content">
              <div class="row ">
                <div class="col-1"></div>
                <div class="col ">
                  <div class="card card-user">
              <div class="card-header">
                <h5 class="card-title">YENİ ÖĞRENCİ KAYDI</h5>
              </div>
              <div class="card-body">
                <form @submit.prevent="onSubmit">
                  <hr>
                   <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label>ADI SOYADI</label>
                        <input v-model="ogrenci.adi"  type="text" class="form-control" placeholder="ADI SOYADI" >
                      </div>
                    </div>      
                  </div>
                  <hr>
                  <h5>GENEL BİLGİLER</h5>
                  <div class="row">
                    <div class="col-md-6 pr-1">
                      <div class="form-group">
                        <label>TC.KİMLİK NO</label>
                        <input v-model="ogrenci.tc"  type="text" class="form-control" placeholder="TC.KİMLİK NO" >
                      </div>
                    </div>
                    <div class="col-md-6 pl-1">
                      <div class="form-group">
                        <label>CİNSİYET</label>
                        <select v-model="ogrenci.cinsiyet" class="custom-select">
                          <option selected>CİNSİYET</option>
                          <option value="ERKEK">ERKEK</option>
                          <option value="KADIN">KADIN</option>
                        </select>
                      </div>
                    </div>
                  </div>

                   <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label>DOĞUM TARİHİ</label>
                        <input v-model="ogrenci.dogumTarihi" type="date" class="form-control" placeholder="DOĞUM TARİHİ" >
                      </div>
                    </div>      
                  </div>

                  <div class="row">
                    <div class="col-md-6 pr-1">
                      <div class="form-group">
                        <label>FAKÜLTE</label>
                        <select v-model="ogrenci.fakulte" class="custom-select">
                          <option selected>FAKÜLTE</option>
                          <option value="İİBF">İİBF</option>
                          <option value="MÜHENDİSLİK">MÜHENDİSLİK</option>
                          <option value="MİMARLIK">MİMARLIK</option>
                          <option value="MYO">MYO</option>
                        </select>
                      </div>
                    </div>
                    <div class="col-md-6 pr-1">
                      <div class="form-group">
                        <label>BÖLÜM</label>
                          <select v-model="ogrenci.bolum" class="custom-select">
                          <option selected>BÖLÜM</option>
                          <option value="BİLGİSAYAR">M.F. | BİLGİSAYAR</option>
                          <option value="EE">M.F. | EE</option>
                          <option value="MAKİNE">M.F. | MAKİNE</option>
                          <option value="YAZILIM">M.F. | YAZILIM</option>
                          <option value="ENDÜSTRİ">M.F. | ENDÜSTRİ</option>
                          <option value="ENDÜSTRİYEL TASARIM">M.T.F. | ENDÜSTRİYEL TASARIM </option>
                          <option value="İÇ MİMARLIK VE ÇEVRE TASARIMI">M.T.F. | İÇ MİMARLIK VE ÇEVRE TASARIMI </option>
                          <option value="EKONOMİ">İİBF | EKONOMİ </option>
                          <option value="U.T.P.">İİBF | U.T.P.</option>
                          <option value="YÖNETİM BİLİŞİM S.">İİBF | YÖNETİM BİLİŞİM S.</option>
                          <option value="BİLGİSAYAR PROGRAMCILIĞI">MYO | BİLGİSAYAR PROGRAMCILIĞI</option>
                          <option value="BİLİŞİM GÜVENLİĞİ T.">MYO | BİLİŞİM GÜVENLİĞİ T.</option>
                          <option value="BİYOMEDİKAL CİHAZ T.">MYO | BİYOMEDİKAL CİHAZ T.</option>
                          <option value="ELEKTRİK">MYO | ELEKTRİK</option>
                          <option value="ELEKTRONİK T.">MYO | ELEKTRONİK T.</option>
                          <option value="E-TİCARET VE PAZARLAMA">MYO | E-TİCARET VE PAZARLAMA</option>
                          <option value="HİBRİT VE ELEKTRİKLİ TAŞITLAR T.">MYO | HİBRİT VE ELEKTRİKLİ TAŞITLAR T.</option>
                          <option value="İNSANSIZ HAVA ARACI TEKNOLOJİSİ VE O.">MYO | İNSANSIZ HAVA ARACI TEKNOLOJİSİ VE O.</option>
                          <option value="LOJİSTİK">MYO | LOJİSTİK</option>
                          <option value="MAKİNE">MYO | MAKİNE</option>
                          <option value="MEKATRONİK">MYO | MEKATRONİK</option>
                        </select>                     
                         </div>
                    </div>
                  </div>

                    <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label>OKUL NO</label>
                        <input v-model="ogrenci.okulNo"  type="text" class="form-control" placeholder="OKUL NO" >
                      </div>
                    </div>      
                  </div>
                  <hr>
                  <h5>İLETİŞİM BİLGİLERİ</h5>

                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label>ADRES</label>
                        <input v-model="ogrenci.adres" type="text" class="form-control" placeholder="Sektör" >
                      </div>
                    </div>      
                  </div>


                  <div class="row">
                    <div class="col-md-6 pr-1">
                      <div class="form-group">
                        <label>Telefon</label>
                        <input v-model="ogrenci.telefon" type="text" class="form-control" placeholder="0(500) XXX XX XX" >
                      </div>
                    </div>
                    <div class="col-md-6 pl-1">
                      <div class="form-group">
                        <label>E Posta</label>
                        <input v-model="ogrenci.eposta" type="text" class="form-control" placeholder="E Posta" >
                      </div>
                    </div>
                  </div>
                  <hr>
                  <h5>OKUL DURUMU</h5>
                    <div class="row">
                    <div class="col-md-6 pr-1">
                      <div class="form-group">
                        <label>MEZUN OLDUĞU OKUL</label>
                        <input v-model="ogrenci.mezunOkul" type="text" class="form-control" placeholder="MEZUN OLDUĞU OKUL" >
                      </div>
                    </div>
                    <div class="col-md-6 pl-1">
                      <div class="form-group">
                        <label>NOT ORTALAMASI</label>
                        <input v-model="ogrenci.notOrt"  type="text" class="form-control" placeholder="NOT ORTALAMASI" >
                      </div>
                    </div>
                  </div>
                  <hr>
                  <h5>STAJ TECRÜBELERİ</h5>
                    <div class="row">
                    <div class="col-md-6 pr-1">
                      <div class="form-group">
                        <label>KURUM ADI</label>
                        <input v-model="ogrenci.kurumAdi" type="text" class="form-control" placeholder="KURUM ADI" >
                      </div>
                    </div>
                    <div class="col-md-6 pl-1">
                      <div class="form-group">
                        <label>DEPARTMAN</label>
                        <input v-model="ogrenci.departman"  type="text" class="form-control" placeholder="DEPARTMAN" >
                      </div>
                    </div>
                  </div>
                  <hr>
                  <h5>PROJE</h5>
                    <div class="row">
                    <div class="col-md-6 pr-1">
                      <div class="form-group">
                        <label>ADI</label>
                        <input v-model="ogrenci.projeAdi"  type="text" class="form-control" placeholder="ADI" >
                      </div>
                    </div>
                    <div class="col-md-6 pl-1">
                      <div class="form-group">
                        <label>GÖREVİ</label>
                        <input v-model="ogrenci.projeGorev"  type="text" class="form-control" placeholder="GÖREVİ" >
                      </div>
                    </div>
                  </div>
                  <hr>
                  <h5>BECERİ VE NİTELİKLER</h5>
                    <div class="row">
                    <div class="col-md-6 pr-1">
                      <div class="form-group">
                        <label>GÜÇLÜ YÖNLER</label>
                        <input v-model="ogrenci.güclüYonler" type="text" class="form-control" placeholder="GÜÇLÜ YÖNLER" >
                      </div>
                    </div>
                    <div class="col-md-6 pl-1">
                      <div class="form-group">
                        <label>ÖZEL İLGİ ALANI</label>
                        <input v-model="ogrenci.ilgiAlani" type="text" class="form-control" placeholder="ÖZEL İLGİ ALANI" >
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6 pr-1">
                      <div class="form-group">
                        <label>KAZANDIĞI ÖDÜL</label>
                        <input v-model="ogrenci.odul"  type="text" class="form-control" placeholder="KAZANDIĞI ÖDÜL" >
                      </div>
                    </div>
                    <div class="col-md-6 pl-1">
                      <div class="form-group">
                        <label>SERTİFİKA</label>
                        <input v-model="ogrenci.sertifika"  type="text" class="form-control" placeholder="SERTİFİKA" >
                      </div>
                    </div>
                  </div>
                  <hr>

                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label>DANIŞMANLIK NOTU</label>
                        <p></p>
                        <textarea v-model="ogrenci.danismanlik" class="form-control textarea"></textarea>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="update ml-auto mr-auto">
                      <button @click="goToBack"   class="btn btn-warning btn-round">Vazgeç</button>
                      <button @click="saveStudent" class="btn btn-success btn-round">Kaydet</button>
                    </div>
                  </div>
                </form>
              </div>
              
            </div>
                </div>
                <div class="col-1"></div>
              </div>
            </div>
</template>

<script>
export default {
  data (){
      return {
        ogrenci : {
            adi : "",
            tc : "",
            cinsiyet : "",
            dogumTarihi : "",
            fakülte :"",
            bolum : "",
            okulNo : "",
            adres : "",
            telefon : "",
            eposta : "",
            mezunOkul : "",
            notOrt : "",
            kurumAdi : "",
            departman : "",
            projeAdi : "",
            projeGorev : "",
            gucluYonler :"",
            ilgiAlani : "",
            odul : "",
            sertifika : "",
            danismanlik : "",
        }
      }
    },
    methods : {
      saveStudent(){
        
        this.$store.dispatch("saveStudent", this.ogrenci);
        this.goToBack();
      },
      goToBack(){
        this.buttonClicked = true
        this.$router.push("/student")
      }
    },
    
}
</script>


// WEBPACK FOOTER //
// src/components/student/StudentNew.vue